export default __webpack_public_path__ + "static/media/046-axe.845f43d1.png";